<template>
	<div class="container-fluid">		

		<div v-if="loading" class="alert-info perso py-3 mx-3 text-center"> Loading please wait <br>
			<span><v-icon class="align-middle" name="sync" spin></v-icon></span>
		</div>

		<div class="" v-if="gene.ensemblID">

			<h5 class="text-center">{{gene.gene_name}}<br><small>{{gene.prot_name}}</small></h5>

			<div class="card mt-3 p-3">
				<div class="col-11">
					<dl class="row">
						<dt class="col-2 ddright">Ensembl ID</dt>
						<dd class="col-4"><a target="_blank" :href="'https://www.ensembl.org/'+gene.taxon+'/Gene/Summary?db=core;g='+gene.ensemblID">{{gene.ensemblID}}</a></dd>
						<dt class="col-2 ddright">Uniprot ID</dt>
						<dd class="col-4"><a target="_blank" :href="'https://www.uniprot.org/uniprot/'+gene.uniprot_id">{{gene.uniprot_id}}</a></dd>
						<dt class="col-2 ddright">Lists</dt>
						<dd class="col-10">
							<div v-if="gene.lists.length">
								<ul>
									<li v-for="list in gene.lists">
										<strong>{{list.display}}</strong> <span v-if="list.difference"> - difference : {{list.difference}}</span><span v-if="list.significance"> - significance : {{list.significance}}</span>
									</li>
								</ul>
							</div>
						</dd>
						<template v-if="advanced">
							<dt class="col-2 ddright">Description</dt>
							<dd class="col-10" style="text-align:justify">{{gene.description}}</dd>
							<dt class="col-2 ddright">Mass</dt>
							<dd class="col-10" style="text-align:justify">{{gene.mass}}</dd>
							<dt class="col-2 ddright">Length</dt>
							<dd class="col-10" style="text-align:justify">{{gene.length_aa}}</dd>
							<dt class="col-2 ddright">Sequence</dt>
							<dd class="col-10" style="text-align:justify">{{gene.sequence}}</dd>
							<dt class="col-2 ddright" v-if="gene.pfam">Pfam</dt>
							<dd class="col-10" v-if="gene.pfam"><span v-for="(pfam,pidx) in gene.pfam"><a target="_blank" :href="'https://pfam.xfam.org/family/'+pfam">{{pfam}}</a><span v-if="pidx<gene.pfam.length-1">, </span></span></dd>
						</template>
						<dt class="col-2 ddright"></dt>
						<dd class="col-10">
							<span class="pointer badge badge-secondary" @click="advanced=!advanced" style="font-style:italic">
								<span v-if="!advanced"><span class="mr-2"><v-icon class="align-middle" style="height:14px" name="plus-square"></v-icon></span>show more details</span>
								<span v-else><span class="mr-2"><v-icon class="align-middle" style="height:14px" name="minus-square"></v-icon></span>hide details</span>
							</span>
						</dd>
						
					</dl>
				</div>
			</div>
			<div class="card mt-3 p-3">	
				<div v-if="proposeDatasets.length">
					
					<h5 class="text-center">Present in {{proposeDatasets.length}} different datasets : </h5>
					<div class="row">
						<div class="col-6">
							<p class="text-center mt-3">
							 Group data by <span v-if="!comparison_type">Replicates</span><span v-else>{{comparisonDisplayed(comparison_type)}}</span> <br>
							<label for="radio_none"> <input class="mr-2" v-model="comparison_type" id="radio_none" type="radio" :value="null"><strong>Replicates</strong> </label>
							<label v-for="v in groupByVar('group')" :for="'GroupByRadio_'+v.name" class="ml-3 pointer">
								<input class="mr-2" v-model="comparison_type" :id="'GroupByRadio_'+v.name" type="radio" :value="v.name"><span><strong>{{comparisonDisplayed(v.name)}}</strong></span> 
							</label>
							</p>
							<!-- <p class="text-center alert-info perso" ><span v-if="comparison_type">Group by : {{comparisonDisplayed(comparison_type)}}</span><span v-else>Group by replicates</span></p> -->
						</div>
						<div class="col-6" v-if="comparison_type !='age' && comparison_type !='Sex'">
							<p class="text-center mt-3"> Color data by {{color_type}} 
								<br>
								<template v-if="!comparison_type">									
									<label v-for="v in groupByVar('color')" :for="'ColorByRadio_'+v.name" class="ml-3 pointer">
										<input class="mr-2" v-model="color_type" :id="'ColorByRadio_'+v.name" type="radio" :value="v.name"><span><strong>{{comparisonDisplayed(v.name)}}</strong></span>
									</label>
									<br>
								</template>
								<span v-for="(col,name) in colorMatching" class="mr-3"><div style="height:15px;width:15px;display:inline-flex" :style="{'background-color':col}"></div> {{name}}<span v-if="color_type=='age'"> months</span></span>
							</p>

						</div>
					</div>
					<hr>
					<div class="row">
						<div class="col-6" v-for="dataset in proposeDatasets" >
						<!-- <div class="col-6" v-for="dataset in proposeDatasets" style="border-right: 1px solid lightgrey;border-bottom: 1px solid lightgrey;"> -->
							<div class="mt-3 mb-3">
								<gene-plot v-if="gene.datasets[dataset.name]&&gene.datasets[dataset.name].data[0]" :gene="gene" :dataset="dataset" :comparison='comparison_type' :color-type="color_type" :color-matching="colorMatching"></gene-plot>
							</div>
						</div>
					</div>
				</div>
				<div v-else>
					<p class="text-center alert alert-secondary" v-if="gene.tax_id=='9606'">Only mouse datasets are available for now</p>
					<p class="text-center alert alert-secondary" v-else>This gene is present in any dataset</p>
				</div>
			</div>		
			
		</div>
	</div>

</template>

<script>	
import {HTTP} from '@/router/http';
import {siteTitle} from '@/app_config';
import { mapGetters } from 'vuex';
import SvgToPng from '@/components/visualization/svgToPng'
import GenePlot from '@/components/visualization/genePlot'

export default {
	name: 'GeneView',
	components:{GenePlot},
	data () {
		return {
			nav:'list',
			advanced:false,
			loading:false,
			current_dataset:{},
			geneData:null,
			comparison_type:null,
			color_type:'nbQ'
		}
	},
	computed:{
		...mapGetters({
			currentUser: 'currentUser',
			datasets:'datasets',
			lists:'lists',
			gene:'current_gene',
			colors:'colors',
		}),

		colorMatching(){
			let _this = this;
			let col = {};
			if (_this.gene.groupByTypes && _this.color_type){
				let data = _this.gene.groupByTypes[_this.color_type].data;
				_.forEach(data,function(d,didx){
					col[d] = _this.colors[didx];
				})
				return col;
			}
		},
		proposeDatasets(){
			let _this = this;
			let gene_datasets = _.map(_.filter(_this.gene.datasets,function(d){return d.status;}),'name');
			let filteredDatasets=_.filter(_this.datasets,function(d){return gene_datasets.indexOf(d.name)>-1;});
			return filteredDatasets;
		},
		
	},
	watch: {
	  $route(to, from) {
			var _this =this;
			console.info("watch",to.params,from.params);
			if (to.params != from.params){
				console.info(to.params.ensemblID);
				_this.searchGene({ensemblID:to.params.ensemblID});
			}
		},
		comparison_type(to,from){
			let _this = this;
			if (to){
				_this.color_type = 'nbQ';
			}
		}
	},
	methods:{
		groupByVar(cas){
			let _this = this;
			let cat = (cas=='group') ? ['genotype','nbQ','housing_condition','age','Sex'] : ['nbQ','age','Sex'];
			let v = _.filter(_this.gene.groupByTypes,function(val,name){
				return cat.indexOf(name)>-1;
			})
			return v;
		},
	  comparisonDisplayed: function (comparison) {
			if (!comparison){ return; }
			let tmp_display = comparison.replace("_"," ");    
	  	let display = tmp_display[0].toUpperCase() + tmp_display.substr(1);
			return display;
		},
		changeNav(nav){
			let _this = this;
			_this.nav = nav;
		},
		
		routeUpdate(obj){
			let _this = this;
			_this.loading = true;
			let query = (obj && obj.ensemblID) ? obj.ensemblID: '';
			_this.$router.push("gene/"+query);
		},
		searchGene(obj){
			let _this = this;
			_this.loading = true;
			_this.$store.dispatch('getGene',obj).then(data => {
				_this.setGene(data);
				_this.loading = false;
			})
		},

		setGene(gene){
			let _this = this;
			console.info(_this.gene);
			if (_this.gene.ensemblID && _this.gene.dataset_names.length){
				_this.current_dataset = _.find(_this.datasets,function(d){return d.name==_this.gene.dataset_names[0];});
				if (_this.current_dataset){
					_this.geneData = _this.gene.datasets[_this.current_dataset.name];
				}
			}
		},
	},
  beforeDestroy() {
		// console.info("bef destroy");
		let _this = this;
		_this.$store.dispatch('resetGene');
  },
	mounted() {
		var _this = this;
		// console.info("mounted");
		_this.$store.dispatch('getDatasets').catch(err => { _this.$snotify.error("Sorry an error occured: "+err) });
		let queryId = _this.$route.params.ensemblID;
		if (queryId && (!_this.gene || queryId!=_this.gene.ensemblID)){
			_this.searchGene({ensemblID:queryId})
		}
	}
}
</script>

// <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
	font-weight: normal;
}
.light-list-group > .list-group-item{
	padding:0px 10px 5px 0;
	border:none;
}

a {
	color: #42b983;
}
</style>
